export default __webpack_public_path__ + "static/media/convocatoriacdmx.82a44d80.pdf";